angular.module('myApp.delivery', ['ngRoute','ngCookies']).config(['$routeProvider', function ($routeProvider) {
	$routeProvider.when('/delivery', {
		templateUrl: 'components/delivery/delivery.html',
		controller: 'deliveryCtrl'
	})
    $routeProvider.when('/business/delivery/track', {
        templateUrl: 'components/delivery/services/track.html',
        controller: 'deliveryCtrl'
    })
	$routeProvider.when('/business/delivery/milk-delivery', {
		templateUrl: 'components/delivery/services/milkDelivery.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/tiffin-delivery', {
		templateUrl: 'components/delivery/services/tiffindelivery.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/food-delivery', {
		templateUrl: 'components/delivery/services/fastFood.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/ecommerce-delivery', {
		templateUrl: 'components/delivery/services/ecommerce.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/cash-collections', {
		templateUrl: 'components/delivery/services/cash.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/cheque-pick-ups', {
		templateUrl: 'components/delivery/services/cheque.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/document-collection', {
		templateUrl: 'components/delivery/services/documentation.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/address-verification', {
		templateUrl: 'components/delivery/services/adress.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/concierge', {
		templateUrl: 'components/delivery/services/concierge.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/kyc', {
		templateUrl: 'components/delivery/services/kyc.html',
		controller: 'deliveryCtrl'
	})
	$routeProvider.when('/business/delivery/wedding-cards', {
		templateUrl: 'components/delivery/services/weddingCards.html',
		controller: 'deliveryCtrl'
	})
    $routeProvider.when('/ads', {
        templateUrl: 'components/delivery/businessad.html',
        controller: 'deliveryCtrl'
    })
    $routeProvider.when('/business/business-suite', {
        templateUrl: 'components/delivery/jungleworks.html',
        controller: 'jungleworksCtrl'
    })
    $routeProvider.when('/business/tracker', {
        templateUrl: 'components/delivery/tracker.html',
        controller: 'deliveryCtrl'
    })
    $routeProvider.when('/business/chat', {
        templateUrl: 'components/delivery/chat.html',
        controller: 'deliveryCtrl'
    })
    $routeProvider.when('/business/storefront', {
        templateUrl: 'components/delivery/storefront.html',
        controller: 'deliveryCtrl'
    })
	$routeProvider.when('/business/delivery/:city_name', {
		templateUrl: 'components/delivery/deliveryCity.html',
		controller: 'deliveryCityCtrl'
	})
	$routeProvider.when('/auto-branding', {
		templateUrl: 'components/delivery/auto_branding.html',
		controller: 'auto_brandingCtrl'
	})
	$routeProvider.when('/out-of-home', {
		templateUrl: 'components/delivery/Out-of-home.html',
		controller: 'out_of_homeCtrl'
	})
	$routeProvider.when('/shop-boards', {
		templateUrl: 'components/delivery/shop_boards.html',
		controller: 'ShopBoardsCtrl'
	})
	$routeProvider.when('/no-parking', {
		templateUrl: 'components/delivery/no_parking.html',
		controller: 'NoParkingCtrl'
	})
	$routeProvider.when('/car-branding', {
		templateUrl: 'components/delivery/car_branding.html',
		controller: 'CarBrandingCtrl'
	})
	$routeProvider.when('/Pamphlet-Insertion-Distribution', {
		templateUrl: 'components/delivery/Pamphlet_Insertion_Distribution.html',
		controller: 'PamphletInsertionDistributionCtrl'
	})
	$routeProvider.when('/newspaper', {
		templateUrl: 'components/delivery/newspaper.html',
		controller: 'newspaperCtrl'
	})
}]).controller('deliveryCtrl', ['$scope', '$rootScope', '$window', '$timeout', 'API', '$location', '$routeParams','$cookieStore', function ($scope, $rootScope,$window, $timeout, API, $location, $routeParams,$cookieStore) {
	console.log("deliveryCtrl -------",$cookieStore)

	API.seDefaultData();
	$window.scrollTo(0, 0);
	$scope.from = "";
	var defaulValues = {};
	$scope.To = "";
	$scope.showfare = false;
    $scope.invalidNumber = false;
	$scope.Heading = "One tap to simplify your deliveries";
	$scope.SubHeading = "Ensuring a seamless delivery experience";
	$scope.url="images/deliveryBack.jpg";
	$scope.trackStatus = "";
	$scope.next_List = 0;
    $scope.scrollTo = function () {
		$('html, body').animate({
			scrollTop: $(".deliveryfooter").offset().top
		}, 1000);
	}
    $scope.ContactUsScroll =function () {
        $('html, body').animate({
            scrollTop: $(".sectionPartner").offset().top
        }, 1000);

    }
	
	
	
		
	setTimeout( function(){
	$('.owl-carousel').owlCarousel({
		margin: 0,
		loop: true,
		items:4,
		autoWidth: true,
		dots: false,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplaySpeed: 1000,
	})
	
}, 0);
	
	
	$scope.pricingCity = 1;

	API.post('https://dodo.jugnoo.in:8024' + '/web/get_sign_up_info', {}).then(function (result) {
		$scope.categories = result.data.category;
		/* $scope.user.category_id = result.data.category[0].category_id;*/
		$scope.cities = result.data.city;

	})
	/*$scope.goTo = function () {
		var param = $scope.selectedCityRoute.city_name.toLowerCase();
		
		$location.path("/business/" + param);
	}*/
	$scope.cityfares = function () {
		$rootScope.loading_custom = true;
		API.post('https://dodo.jugnoo.in:8024/web/get_city_fares_for_web', {
			city_id: $scope.pricingCity,
		}).then(function (result) {
			$scope.shipment = result.data.data.fare;
			$rootScope.loading_custom = false;
		})
	}
    
    $scope.cityfares();


    $scope.trackOrders = function(id){
        API.post('https://dodo.jugnoo.in:8024' + '/web/get_delivery_tracking_status', {
            ref_id:id
        }).then(function (result) {
            if(result.data.flag === 143){
                $scope.trackStatus = result.data.message;
			}
			else{
                $scope.trackStatus = result.data.error;
			}

        })
    }

	
  
  /*$scope.contentChange = function(name) {
	 
	  for(var i=0;i<content.length;i++) {
		 if(content[i].name == name) {
			 $scope.Heading = content[i].headline;
			 $scope.SubHeading = content[i].subheading;
			 $scope.url = content[i].url;
  
			 console.log("url("+$scope.url+")");
			 $("#header").css("background", "url("+$scope.url+")");
   
			$("#Milk Delivery").addClass('itemActive');
			
		 }
		  else{
			 console.log(content[i].name);
			  $('#'+content[i].name).removeClass('itemActive');
		  }
	  }
	  $window.scrollTo(0, 0);
  }*/

	
    $scope.gstVerify = function()
    {
         if ($scope.user.gst_number) {
            $scope.gstNumber = $scope.user.gst_number.toUpperCase();
            var gstNumber = $scope.user.gst_number.toUpperCase();
            //check the string doesn't contain any special characters
            if (/^[a-zA-Z0-9- ]*$/.test(gstNumber) == false) {
                $scope.invalidNumber = true;
                return;
            }
            //check the string length and ensure the 13th character is Z
            else if (gstNumber.length != 15 || gstNumber.charAt(13) != 'Z') {
                $scope.invalidNumber = true;
                return;
            }
            // The first two digits should be between 1 and 35
            else if (isNaN(parseInt(gstNumber.substring(0, 2))) || parseInt(gstNumber.substring(0, 2)) > 35 || parseInt(gstNumber.substring(0, 2)) < 1) {
                $scope.invalidNumber = true;
                return;
            }
            // Pan must contain at least one character
            else if (/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/.test(gstNumber.substring(2,12)) == false) {
                $scope.invalidNumber = true;
                return;
            }
            else {
                $scope.invalidNumber = false;
            }
        } else {
            $scope.invalidNumber = false;
        }
        
    };


	$.getJSON("https://jsonip.com?callback=?", function(e) {
		$scope.session_ip = e.ip;
		console.log("Your ip: " + e.ip);
	});

	jQuery.ajax({
		type: "get",
		url: "https://ip.tookanapp.com:8000/requestCountryCodeGeoIP2",
		data: {},
		dataType: "JSON",
		success: function(e) {
			$scope.ipconfig_new = e.data;
		}
	});


	$scope.isclicked = false;
	$scope.checkError = false;
	console.log("document.referrer",document.referrer)
	
	$rootScope.$on('$locationChangeStart', function (event, current, previous) {
		sessionStorage.setItem("previous_page",previous);
	});
	
	$scope.register = function () {
		if($scope.myForm.$invalid) {
			$scope.checkError = true;
			return;
		}

		// var previousValues = JSON.parse(sessionStorage.getItem("getDeafultValues"));
		var previousValues	= JSON.parse($cookieStore.get("getDeafultValues"))

		console.log("<><><>previousvalue",previousValues)
		var uber_for = $scope.user.business_name;
		var first_name = $scope.user.first_name;
		var email1 = $scope.user.email_id;
		var email = email1.replace(/\s+/g, '');
		// var tel = jQuery("#txwCPhone").val();
		// var phone = jQuery(".selected-dial-code").html()+"-"+tel;
		var phone = $scope.user.phone_no;
		var message =$scope.user.message;
		var url = window.location.href;
		var offering = "17";
		var productname = "Jugnoo Ads";
		var source= previousValues.new_source;
		var medium= previousValues.new_medium;
		var old_source= previousValues.old_source;
		var old_medium= previousValues.old_medium;
		var utm_campaign= previousValues.new_campaign;
		var utm_term= previousValues.term;
		var gclid= previousValues.gclid;
		// var prevPage = document.referrer;
		// var previous_page = prevPage;

		// var previous_page = document.referrer;
		var previous_page = sessionStorage.getItem("previous_page");
		console.log("----------",previous_page,previousValues,$cookieStore.get('defaulValues'));
		// Cookies.get('defaulValues');
		var session_ip = $scope.session_ip;
		var Campaign_old = previousValues.old_campaign;
		var vertical_page = url;
		

		$scope.isclicked = true;
		// "https://api.jungleworks.co/marketing/addUser"   --- live url,
		API.post('https://api.jungleworks.co/marketing/addUser',{
			email:email,
			last_name :"",
			first_name:first_name,
			phone:phone,
			message:message,
			timezone:new Date().getTimezoneOffset(),
			url:url,
			session_ip:session_ip,
			source:source,
			medium:medium,
			utm_campaign:utm_campaign,
			utm_term:utm_term,
			old_source:old_source,
			old_medium:old_medium,
			gclid:gclid,
			vertical_page:vertical_page,
			ctaType:2,
			offering:offering,
			productname:productname,
			ipconfig:$scope.ipconfig_new,
			uber_for:uber_for,
			previous_page:previous_page,
			old_utm_campaign:Campaign_old

		}).then(function (result) {
			console.log(result);
						if (result.data.status == 200) {
							$scope.heading = "Thankyou!";
							$scope.message = "form submitted successfully!";
							$("#Error").modal();
							
							$scope.isclicked = false;
						}
						else
						{
							$scope.heading = "Sorry";
							$scope.message = "some error occurred";
						}

						document.forms["myForm"].reset();
			$scope.checkError = false;
			$scope.myForm.first_name.$touched = false;
			$scope.myForm.phnNo.$touched = false;
			$scope.myForm.email.$touched = false;
		})

	};

	$scope.clearDataOfform = function () {
		$scope.user ={};
		$scope.City='';
		$scope.myForm.$setPristine();
		$scope.myForm.$setUntouched();
	};

	$scope.goToBottompage = function () {
		//location.href = "#get-in-touch";
		window.scrollTo(0,document.body.scrollHeight - 1000);
	};
	
	$scope.imageArray = [
			{name:'images/rentmojo.png',active:1},
			{name:'images/vodafone.png',active:1},
			{name:'images/chandigarh-uni.png',active:1},
			{name:'images/career.jpg',active:1},
			{name:'images/zolo.png',active:0}
		];

	$scope.rotateRight = function () {

		var getLastImage =  angular.copy($scope.imageArray[$scope.imageArray.length -1]);
		$scope.imageArray.pop();
		$scope.imageArray.unshift(getLastImage);
		$scope.imageArray[0].active = 1;
		$scope.imageArray[$scope.imageArray.length -1].active = 0;

	};

	$scope.rotateLeft = function () {

		var getFirstImage =  angular.copy($scope.imageArray[0]);
		$scope.imageArray.shift();
		$scope.imageArray[$scope.imageArray.length -1].active = 1;
		$scope.imageArray.push(getFirstImage);
		$scope.imageArray[$scope.imageArray.length -1].active = 0;
		
	};


	
	// $scope.register = function () {
	// 	var name =  $("#name").val();
	// 	var email = $("#email").val();
	// 	var company_name = $("#company_name").val();
	// 	var phone_number = $("#phone_number").val();
	//
     //
     //    API.post('https://dodo.jugnoo.in:8024/web/send_lead_email', {
	// 		    user_name: name || '',
	// 			phone_no: phone_number.toString(),
	// 			business_name: company_name,
	// 			email: email || '',
	// 			city: $scope.City || '',
	// 			category: $scope.question || ''
    //
	// 	}).then(function (result) {
    //
	// 			if (result.data.flag==143) {
	// 				$scope.heading = "Thankyou!";
	// 				$scope.message = "form submitted successfully!";
     //
	// 				$("#Error").modal();
	// 			}
	// 			else
	// 			{
	// 				$scope.heading = "Sorry";
	// 				$scope.message = "some error occurred";
	// 			}
    //
	// 			document.forms["myForm"].reset();
	// 		})
	// }
    

	
	
	
}]).controller('deliveryCityCtrl', ['$scope', '$rootScope', '$window', '$timeout', 'API', '$routeParams', '$location','$cookieStore', function (
	$scope, $rootScope, $window, $timeout, API, $routeParams, $location,$cookieStore) {

	var defaulValues = {};
	console.log("inside the delivery city");

	defaulValues.source = $location.search().utm_source ? $location.search().utm_source  : 'NA' ;
	defaulValues.medium = $location.search().utm_medium ? $location.search().utm_medium : 'NA' ;
	defaulValues.campaign = $location.search().utm_campaign ? $location.search().utm_campaign : 'NA';
	sessionStorage.setItem("getDeafultValues",JSON.stringify(defaulValues));
	if(sessionStorage.getItem("getDeafultValues")){
		defaulValues.source =sessionStorage.getItem("getDeafultValues").source
	defaulValues.medium = sessionStorage.getItem("getDeafultValues").medium
	defaulValues.campaign = sessionStorage.getItem("getDeafultValues").campaign
	}

	$cookieStore.put('defaulValues', JSON.stringify(defaulValues));
	console.log($cookieStore.get('defaultValues'))

		$scope.cityName = $routeParams.city_name;
		$scope.cityName = $scope.cityName.charAt(0).toUpperCase() + $scope.cityName.substr(1).toLowerCase();
        console.log($scope.cityName);
	
        
	$window.scrollTo(0, 0);
	$scope.from = "";
	$scope.To = "";
	$scope.showfare = false;
    $scope.invalidNumber = false;
    $scope.cities= {};
    $scope.selectedCity={};        
        
		
  var content = [
	  {
		name :"Milk",
		headline :"Milk & More. Every morning!",
		subheading :"We deliver milk, bread, egg and other daily need items to your customer's doorstep."  
	  },
	  {
		name :"Tiffin",
		headline :"Breakfast, Lunch or Dinner. Delivered hot!",
		subheading :"We will pick up the meals from your doorstep and deliver it on time to your customers!"  
	  },
	  {
		name :"Food Delivery",
		headline :"Restaurant to Customer. Delivered fast!",
		subheading :"We will pick up food from your doorstep and deliver it on time to your customers!"  
	  },
	  {
		name :"ECommerce Delivery",
		headline :"Anything to Everything. Shiping made easy!",
		subheading :"We provide seamless parcel pick-up, deliver and return from warehouse to customer."  
	  },
	  {
		name :"Cash Collections",
		headline :"Safe, Secure and Economical cash transit!",
		subheading :"We provide cash pick up and dispatch service from your customers and business partners."  
	  },
	  {
		name :"Cheque Pick Ups",
		headline :"Safe, Secure and Economical cheque transit!",
		subheading :"We provide cheque pick up and collection service from your customers and business partners."  
	  },
	  {
		name :"Document Collection",
		headline :"Safe, Secure and Economical document transit!",
		subheading :"Documents are handled professionally, collected promptly and returned quickly"  
	  },
	  {
		name :"Address Verification",
		headline :"Efficient, Reliable & Economical address verification!",
		subheading :"Physical field verification of permanent, temporary or residential, business addresses."  
	  },
	  {
		name :"Concierge",
		headline :"On demand personal assistant to run errands!",
		subheading :"A perfect time management system for personal or professional requirements."  
	  },
	  {
		name :"KYC",
		headline :"Quick and efficient verification of customers!",
		subheading :"We provide simplified KYC verification and documentation of your customers, on your behalf."  
	  }
  ]
	
  
  $scope.contentChange = function(name) {
	  for(var i=0;i<content.length;i++) {
		 if(content[i].name == name) {
			 $scope.Heading = content[i].heading;
			 $scope.SubHeading = content[i].subheading;
		 }
	  } 
  }

        
        $scope.getCityFare = function () { 
        	$rootScope.loading_custom = true;
		API.post('https://dodo.jugnoo.in:8024/web/get_city_fares_for_web', {
          
			city_id: $scope.selectedCity.city_id,
		}).then(function (result) {
			$rootScope.loading_custom = false;
			$scope.shipment = result.data.data.fare;
		})
   }
   
        
        
        API.post('https://dodo.jugnoo.in:8024' + '/web/get_sign_up_info', {}).then(function (result) {
       $scope.categories = result.data.category;
       $scope.cities = result.data.city;
        for (var i = 0; i < $scope.cities.length; i++) {
          
			if ($scope.cities[i].city_name == $scope.cityName) {
				console.log("<><><<>>selected",$scope.cities[i])
				$scope.selectedCity= $scope.cities[i];
                $scope.getCityFare();
				break;
			}
		}    
               
        })
            
    
       
	
	$scope.scrollTo = function () {
		$('html, body').animate({
			scrollTop: $(".deliveryfooter").offset().top
		}, 1000);
	}
    $scope.ContactUsScroll =function () {
        $('html, body').animate({
            scrollTop: $(".sectionPartner").offset().top
        }, 1000);

	}

	$('.selectpicker').selectpicker({
		size: 4
	});
			
		
	$('.owl-carousel').owlCarousel({
		margin: 0,
		autoWidth: true,
		loop: true,
		dots: false,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplaySpeed: 1000,
	})
    

 
    

		$scope.register = function () {
		var name =  $("#name").val();
		var email = $("#email").val();
		var company_name = $("#company_name").val();
		var phone_number = $("#phone_number").val();
		
       
        API.post('https://dodo.jugnoo.in:8024/web/send_lead_email', {
			    user_name: name || '',
				phone_no: phone_number.toString(),
				business_name: company_name,
				email: email || '',
				city: $scope.City || '',
				category: $scope.question || '',

		}).then(function (result) {

				if (result.data.flag==143) {
					$scope.heading = "Thankyou!";
					$scope.message = "form submitted successfully!";
                    
					$("#Error").modal();
				}
				else
				{
					$scope.heading = "Sorry";
					$scope.message = "some error occurred";
				}

				document.forms["myForm"].reset();
			})
	}
     
	$scope.Tolat = "";
	$scope.Tolong = "";
	$scope.Fromlat = "";
	$scope.fromlong = "";
	$scope.vehicle_value = "";
	$scope.fare = "";

	$scope.destchangefunc = function () {
		if ($scope.To) {
           
	         
				if($scope.To.indexOf($scope.selectedCity.city_name) == 0) {
					
				} 
				else {

					if ($scope.selectedCity.city_name.indexOf($scope.To) >= 0) {
			    		$scope.To = $scope.selectedCity.city_name;

					} else {
					  		$scope.To= $scope.selectedCity.city_name+", "+$scope.To;
					}
			    }

				geocoder = new google.maps.Geocoder();
				if (geocoder) {
					geocoder.geocode({
						'address': $scope.To
					}, function (results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							$scope.Tolat = results[0].geometry.location.lat();
							$scope.Tolong = results[0].geometry.location.lng();
							if ($scope.From != "" && $scope.vehicle_value != "" && $scope.vehicle_value != null) $scope.getFare();
						}
					})
				}
			
			
	}   }

    
  
    
	$scope.fromchangefunc = function () {
		if ($scope.from) {
			
				if($scope.from.indexOf($scope.selectedCity.city_name) == 0) {
					
				}
				 else {
						if ($scope.selectedCity.city_name.indexOf($scope.from) >= 0) {
				    	$scope.from = $scope.selectedCity.city_name;
				    } else {
				  		$scope.from= $scope.selectedCity.city_name+", "+$scope.from;
				   }
				}
				geocoder = new google.maps.Geocoder();
				if (geocoder) {
					geocoder.geocode({
						'address': $scope.from
					}, function (results, status) {
						if (status == google.maps.GeocoderStatus.OK) {
							$scope.Fromlat = results[0].geometry.location.lat();
							$scope.Fromlong = results[0].geometry.location.lng();
							if ($scope.To != "" && $scope.vehicle_value != "" && $scope.vehicle_value != null) $scope.getFare();
						}
					})
				}
			} 
			
	}
	$scope.changeVehicle = function (vehicle) {
		if ($scope.from != "" && $scope.To != "") $scope.getFare();
	}
	$scope.getFare = function () {
		$rootScope.loading_custom = true;
		$scope.deliveries = [];
		$scope.obj1 = {
			'is_unloading': 0,
			'latitude': $scope.Tolat,
			'longitude': $scope.Tolong
		}
		$scope.deliveries.push($scope.obj1);
		API.post('https://dodo.jugnoo.in:8024/web/fetch_estimated_fare', {
			"pickup_latitude": $scope.Fromlat,
			"pickup_longitude": $scope.Fromlong,
			"is_loading": 0,
			"vehicle_type": $scope.vehicle_value,
			"has_return": 0,
			"deliveries": $scope.deliveries,
		}).then(function (result) {
			$scope.fare = result.data.fare;
			$rootScope.loading_custom = false;
			$scope.showfare = true;
		})
	}
	

	
	$scope.getLocation = function () {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(function (position) {
				var self = $scope;
				$scope.Tolat = position.coords.latitude;
				$scope.Tolong = position.coords.longitude;
				var latlng = new google.maps.LatLng($scope.Tolat, $scope.Tolong);
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({
					'location': latlng
				}, function (results, status) {
					if (status === 'OK') {
						self.To = results[0].formatted_address;
						$scope.$digest();
						if ($scope.from != "" && $scope.vehicle_value != "" && $scope.vehicle_value != null) {
							$scope.getFare();
						}
					}
				});
			});
		} else {
			var message = "Geolocation is not supported by this browser.";
		}
	}
}])
	/*.directive('googleplace', function () {
	return {
		require: 'ngModel',
		link: function (scope, element, attrs, model) {
			var options = {
				types: [],
				componentRestrictions: {}
			};
			scope.gPlace = new google.maps.places.Autocomplete(element[0], options);
			google.maps.event.addListener(scope.gPlace, 'place_changed', function () {
				scope.$apply(function () {
					model.$setViewValue(element.val());
				});
			});
		}
	};
})*/
.controller('jungleworksCtrl', ['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location', function($scope, $window, $rootScope, API, $routeParams, $location) {


    $window.scrollTo(0,0);
    $scope.phoneNumber = /^\+?\d{2}[- ]?\d{3}[- ]?\d{5}$/;
    $('.owl-carousel').owlCarousel({
        loop:true,
        margin:0,
        nav:false,
        autoplay: true,
        autoplayTimeout: 6000,
        autoplaySpeed: 2000,
        dots: true,
        responsive:{
            0:{
                items:1,
            },
            600:{
                items:1,
            },
            1000:{
                items:1
            }
        }
    })
    $scope.onSubmit = function () {
        $scope.buttonLoader =true;
        API.post('https://webapi.clicklabs.in/jw/cta/cta.php', {
            orgname:'jugnoo',
            name: $scope.user.name,
            email: $scope.user.email,
            phone: $scope.user.phno,
            message: $scope.user.message,
            url:"",
            utm_source:"",
            utm_medium:"",
            old_source:"",
            old_medium:"",
            gclid:"",
            previous_page:"",
            vertical_page:"Jugnoo Business Suite",
            referrer:"",
            web_referrer:"",
            product_name:'jw_jugnoo',
            summittype:'MainCta',
            type:1,
            formid:1
        }).then(function (result) {
            $('#myModal').modal('hide');
            $('#thankModal').modal('show');
            $('.thank-form-none')[0].reset();
            $scope.buttonLoader =false;
        })
    }
    API.post('https://dodo.jugnoo.in:8024' + '/web/get_sign_up_info', {}).then(function (result) {
        $scope.categories = result.data.category;
        $scope.cities = result.data.city;
    })
    $scope.register = function () {
        var name = $("#name").val();
        var email = $("#email").val();
        var company_name = $("#company_name").val();
        var phone_number = $("#phone_number").val();
        if(!company_name) {
            $scope.formerror = "Business name required"
        }
        else if(!phone_number) {
            $scope.formerror = "Phone No required"
        }
        else if( !$scope.phoneNumber.test(phone_number)) {
            $scope.formerror = "Phone No is invalid"
        }
        else {
            API.post('https://dodo.jugnoo.in:8024/web/send_lead_email', {
                user_name: name || '',
                phone_no: phone_number.toString(),
                business_name: company_name,
                email: email || '',
                city: $scope.City || '',
                category: $scope.question || '',
            }).then(function (result) {
                if (result.data.flag == 143) {
                    $scope.heading = "Thankyou!";
                    $scope.message = "form submitted successfully!";
                    $("#Error").modal();
                }
                else {
                    $scope.heading = "Sorry";
                    $scope.message = "some error occurred";
                }
                $scope.formerror="";
                document.getElementById("businessForm").reset();
            })
        }
    }
}]).controller('auto_brandingCtrl',['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location',function($scope, $window, $rootScope, API, $routeParams, $location){
	window.onbeforeunload = function () {
		console.log("><><<>")
		window.scrollTo(0, 0);
	  }
	  window.onbeforeunload();
	  $scope.next_active=true;
	 $scope.previous_active=false
var image=[{
	src:'/images/1 (4).png'
},
{
	src:'/images/2 (1) (1).png'
},
{
	src:'/images/3 (1) (1).png'
},
{
	src:'/images/4 (1).png'
},
{
	src:'/images/5 (1).png'
},
{
	src:'/images/6 (1).png'
},
{
	src:'/images/7 (1).png'
}
]

var largeImages=[{
	src:'/images/autobrandlarge1.jpg'
},
{
	src:'/images/autobrandlarge2.jpg'
},
{
	src:'/images/autobrandlarge3.jpg'
},
{
	src:'/images/autobrandlarge4.jpg'
},
{
	src:'/images/autobrandinglarge5.jpg'
},
{
	src:'/images/7 (2) (1).jpg'
},
{
	src:'/images/autobrandlarge7.jpg'
}
]

var stickerImages=[{
	src:'/images/autobrandingsmall.png'
},
{
	src:'/images/autosticker2 (5).png'
},
{
	src:'/images/autosticker3 (3).png'
}
]


var stickerLargeImages=[{
	src:'/images/sticker1.jpg'},
	{src:'/images/sticker2.jpg'},
	{src:'/images/sticker3.jpg'}
]

var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
console.log("><><width",width)
if(width<=951 && width>768){
$scope.noimages=3;
$scope.nostickerimages=3
}else if(width<=768)
{
	$scope.noimages=1;
	$scope.nostickerimages=1
}
else
{
	$scope.noimages=3;
	$scope.nostickerimages=3
}
console.log("<><><><show",image)
$scope.ShownImages=[];
$scope.ShownImages = image.slice();
console.log("shownimage",$scope.ShownImages)
var ImageIndex =0;
$scope.previousImage = function(){
	// console.log("previous",image,$scope.ShownImages)
if(ImageIndex < image.length && ImageIndex!=0){
	// console.log("previousif",$scope.ShownImages,ImageIndex)
	$scope.ShownImages.splice(0,0,image[ImageIndex-1])
	// console.log("previousif",$scope.ShownImages)
	ImageIndex--;
	$scope.next_active=true;
	if(ImageIndex == 0 ){
		$scope.previous_active=false;
	}
}
}

$scope.nextImage = function(){
	console.log("nextr",ImageIndex+$scope.noimages,image.length)
	// console.log("previous",image,$scope.ShownImages)
	if(ImageIndex+$scope.noimages < image.length){
		console.log("nextr",ImageIndex+$scope.noimages,image.length)	
		$scope.ShownImages.splice(0,1)
		// console.log("previous",image,$scope.ShownImages)
		ImageIndex++;
		$scope.previous_active=true
		if(ImageIndex+$scope.noimages == image.length){
			$scope.next_active=false
		}
	}
}

$scope.openImage = function(index,type){
	// console.log("<><openimage",index)
	var modal = document.getElementById('myModal');
	var modalImg = document.getElementById("img01");
	modal.style.display = "block";
	// console.log("<><<>largeImages[index]"),largeImages[index]
	if(type=="hoods")
	modalImg.src = largeImages[index+ImageIndex].src;
	else
	modalImg.src= stickerLargeImages[index+stickerImageIndex].src;
}


$scope.closeImg = function(){

	var modal = document.getElementById('myModal');
	modal.style.display = "none";
}


var stickerImageIndex=0;
$scope.sticker_next_active=true;
$scope.StickerShownImages=stickerImages.slice()

$scope.stickerpreviousImage = function(){
	if(stickerImageIndex < stickerImages.length && stickerImageIndex!=0){
		$scope.StickerShownImages.splice(0,0,stickerImages[stickerImageIndex-1])
		stickerImageIndex--;
		$scope.sticker_next_active=true;
		if(stickerImageIndex==0 ){
			$scope.sticker_previous_active=false;
		}
	}
}

$scope.stickernextImage = function(){
	if(stickerImageIndex+$scope.noimages < stickerImages.length){
			$scope.StickerShownImages.splice(0,1);
		stickerImageIndex++;
		$scope.sticker_previous_active=true
		if(stickerImageIndex+$scope.noimages == stickerImages.length)
		$scope.sticker_next_active=false;
	}
	}


$scope.notcloseImage=function(event){
	event.stopImmediatePropagation();
    return false;
}
$scope.escImg =function(event){
	if ($event.keyCode == 27) {
		$scope.closeImg()
	}
}


}]).controller('out_of_homeCtrl',['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location',function($scope, $window, $rootScope, API, $routeParams, $location){
	window.onbeforeunload = function () {
		console.log("><><<>")
		window.scrollTo(0, 0);
	  }
	  window.onbeforeunload()
	var image=[{
		src:'/images/otofhome1.png'
	},
	{
		src:'/images/smalloutofhome2.png'
	},
	{
		src:'/smalloutofhome3.png'
	},
	{
		src:'/images/4 (1).png'
	},
	{
		src:'/images/5 (1).png'
	},
	{
		src:'/images/6 (1).png'
	},
	{
		src:'/images/7 (1).png'
	}
	]

	var largeImages=[{
		src:'/images/largeoutofhome1.png'
	},
	{
		src:'/images/largeoutofhome2.jpg'
	},
	{
		src:'/images/largeoutofhome3.png'
	},
	{
		src:'/images/autobrandlarge4.jpg'
	},
	{
		src:'/images/autobrandinglarge5.jpg'
	},
	{
		src:'/images/autobrandinglarge5.jpg'
	},
	{
		src:'/images/autobrandlarge7.jpg'
	}
	]

	var stickerImages=[{
		src:'/images/otofhome1.png'
	},
	{
		src:'/images/smalloutofhome2.png'
	},
	{
		src:'/images/smalloutofhome3.png'
	},
	]


	var stickerLargeImages=[{
		src:'/images/largeoutofhome1.png'
	},
	{
		src:'/images/largeoutofhome2.jpg'
	},
	{
		src:'/images/largeoutofhome3.png'
	},
	]

	var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	console.log("><><width",width)
	if(width<=951 && width>768){
	$scope.noimages=3;
	}else if(width<=768)
	{
		$scope.noimages=1
	}
	else
	{
		$scope.noimages=3
	}
	console.log("<><><><show",image)
	$scope.ShownImages=[];
	$scope.ShownImages = image.slice();
	console.log("shownimage",$scope.ShownImages)
	var ImageIndex =0;
	$scope.previousImage = function(){
		console.log("previous",image,$scope.ShownImages)
	if(ImageIndex < image.length && ImageIndex!=0){
		console.log("previousif",$scope.ShownImages,ImageIndex)
		$scope.ShownImages.splice(0,0,image[ImageIndex-1])
		console.log("previousif",$scope.ShownImages)
		ImageIndex--;
	}
	}

	$scope.nextImage = function(){
		console.log("nextr")
		console.log("previous",image,$scope.ShownImages)
		if(ImageIndex+2 < image.length){
			// for(var  i=0;i<6;i++){
			// 	$scope.ShownImages[i]=$scope.ShownImages[i+1]
			// }
			$scope.ShownImages.splice(0,1)
			console.log("previous",image,$scope.ShownImages)
			ImageIndex++;
		}
	}

	$scope.openImage = function(index,type){
		console.log("<><openimage")
		var modal = document.getElementById('myModal');
		var modalImg = document.getElementById("img01");
		modal.style.display = "block";
		console.log("<><<>largeImages[index]"),largeImages[index]
		if(type=="hoods")
		modalImg.src = largeImages[index].src;
		else
		modalImg.src= stickerLargeImages[index].src;
	}


	$scope.closeImg = function(){
		var modal = document.getElementById('myModal');
		modal.style.display = "none";
	}


	var stickerImageIndex=0;
	$scope.StickerShownImages=stickerImages.slice()

	$scope.stickerpreviousImage = function(){
		if(stickerImageIndex < stickerImages.length && stickerImageIndex!=0){
			$scope.StickerShownImages.splice(0,0,stickerImages[stickerImageIndex-1])
			stickerImageIndex--;
		}
	}

	$scope.stickernextImage = function(){
		if(stickerImageIndex+2 < stickerImages.length){
			for(var  i=0;i<3;i++){
				$scope.StickerShownImages[i]=$scope.StickerShownImages[i+1]
			}
			stickerImageIndex++;
		}
	}
	}]).controller('ShopBoardsCtrl',['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location',function($scope, $window, $rootScope, API, $routeParams, $location){
		window.onbeforeunload = function () {
			window.scrollTo(0, 0);
		  }
		  window.onbeforeunload()

	
	
		var stickerImages=[{
			src:'/images/smallshopboard1.png'
		},
		{
			src:'/images/smallshopboard2.png'
		},
		{
			src:'/images/smallshopboard3.png'
		},
		]
	
	
		var stickerLargeImages=[{
			src:'/images/largeshopboard1.png'
		},
		{
			src:'/images/largeshopboard2.png'
		},
		{
			src:'/images/largeshopboard3.png'
		},
		]
	
		var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		if(width<=951 && width>768){
		$scope.noimages=3;
		}else if(width<=768)
		{
			$scope.noimages=1
		}
		else
		{
			$scope.noimages=3
		}

		var ImageIndex =0;

	
	
		$scope.openImage = function(index,type){
			// console.log("<><openimage")
			var modal = document.getElementById('myModal');
			var modalImg = document.getElementById("img01");
			modal.style.display = "block";
			// console.log("<><<>largeImages[index]"),largeImages[index]
			if(type=="hoods")
			modalImg.src = largeImages[index].src;
			else
			modalImg.src= stickerLargeImages[index].src;
		}
	
	
		$scope.closeImg = function(){
			var modal = document.getElementById('myModal');
			modal.style.display = "none";
		}
	
	
		var stickerImageIndex=0;
		$scope.StickerShownImages=stickerImages.slice()
	
		$scope.stickerpreviousImage = function(){
			if(stickerImageIndex < stickerImages.length && stickerImageIndex!=0){
				$scope.StickerShownImages.splice(0,0,stickerImages[stickerImageIndex-1])
				stickerImageIndex--;
			}
		}
	
		$scope.stickernextImage = function(){
			if(stickerImageIndex+2 < stickerImages.length){
				for(var  i=0;i<3;i++){
					$scope.StickerShownImages[i]=$scope.StickerShownImages[i+1]
				}
				stickerImageIndex++;
			}
		}
		$scope.notcloseImage=function(event){
			event.stopImmediatePropagation();
			return false;
		}

		}])
		.controller('CarBrandingCtrl',['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location',function($scope, $window, $rootScope, API, $routeParams, $location){
			window.onbeforeunload = function () {
				console.log("><><<>")
				window.scrollTo(0, 0);
			  }
			  window.onbeforeunload();
			  $scope.next_active= true;
		var image=[{
			src:'/images/smallcarsunshades1.png'
		},
		{
			src:'/images/smallcarsunshades2.png'
		},
		{
			src:'/images/smallcarsunshades3.png'
		},
		{
			src:'/images/smallcarshades4.png'
		},
		]
		
		var largeImages=[{
			src:'/images/largcarsunshades1.png'
		},
		{
			src:'/images/largecarsunchades2.png'
		},
		{
			src:'/images/largecarsundhades3.png'
		},
		{
			src:'/images/largecarsunshades4.png'
		},
		]
		
		var stickerImages=[{
			src:'/images/smallCarwarp1.png'
		},
		{
			src:'/images/smallcarwrap2.png'
		},
		]
		
		
		var stickerLargeImages=[{
			src:'/images/largeCarwarp1.png'},
			{src:'/images/largeCarWraps2.jpg'},
		]
		
		var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		console.log("><><width",width)
		if(width<=951 && width>768){
		$scope.noimages=3;
		}else if(width<=768)
		{
			$scope.noimages=1
		}
		else
		{
			$scope.noimages=3
		}
		console.log("<><><><show",image)
		$scope.ShownImages=[];
		$scope.ShownImages = image.slice();
		console.log("shownimage",$scope.ShownImages)
		var ImageIndex =0;
		$scope.previousImage = function(){
			console.log("previous",image,$scope.ShownImages)
		if(ImageIndex < image.length && ImageIndex!=0){
			console.log("previousif",$scope.ShownImages,ImageIndex)
			$scope.ShownImages.splice(0,0,image[ImageIndex-1])
			console.log("previousif",$scope.ShownImages)
			ImageIndex--;
			if(ImageIndex==0){
				$scope.previous_active=false;
				$scope.next_active=false;
			}
			$scope.next_active=true;
		}
		
		}
		
		$scope.nextImage = function(){
			console.log("nextr")
			console.log("previous",image,$scope.ShownImages)
			if(ImageIndex+$scope.noimages < image.length){
				$scope.ShownImages.splice(0,1)
				console.log("previous",image,$scope.ShownImages)
				ImageIndex++;
				$scope.previous_active=true;
				if(ImageIndex+$scope.noimages == image.length){
					$scope.previous_active=true;
					$scope.next_active=false
				}
				
			}		
		}
		
		$scope.openImage = function(index,type){
			console.log("<><openimage",index,type,stickerImageIndex)
			var modal = document.getElementById('myModal');
			var modalImg = document.getElementById("img01");
			modal.style.display = "block";
			console.log("<><<>largeImages[index]"),largeImages[index]
			if(type=="hoods")
			modalImg.src = largeImages[index+ImageIndex].src;
			else
			modalImg.src= stickerLargeImages[index+stickerImageIndex].src;
		}
		
		
		$scope.closeImg = function(){
			var modal = document.getElementById('myModal');
			modal.style.display = "none";
		}
		
		
		
var stickerImageIndex=0;
$scope.sticker_next_active=true;
$scope.StickerShownImages=stickerImages.slice()

$scope.stickerpreviousImage = function(){
	if(stickerImageIndex < stickerImages.length && stickerImageIndex!=0){
		$scope.StickerShownImages.splice(0,0,stickerImages[stickerImageIndex-1])
		stickerImageIndex--;
		$scope.sticker_next_active=true;
		if(stickerImageIndex==0 ){
			$scope.sticker_previous_active=false;
		}
	}
}

$scope.stickernextImage = function(){
	if(stickerImageIndex+$scope.noimages < stickerImages.length){
			$scope.StickerShownImages.splice(0,1);
		stickerImageIndex++;
		$scope.sticker_previous_active=true
		if(stickerImageIndex+$scope.noimages == stickerImages.length)
		$scope.sticker_next_active=false;
	}
	}
	$scope.notcloseImage=function(event){
		event.stopImmediatePropagation();
		return false;
	}
		}]).controller('NoParkingCtrl',['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location',function($scope, $window, $rootScope, API, $routeParams, $location){
			window.onbeforeunload = function () {
				console.log("><><<>")
				window.scrollTo(0, 0);
			  }
			  window.onbeforeunload();
			  $scope.next_active=true;
		var image=[{
			src:'/images/smallnoparking1.png'
		},
		{
			src:'/images/smallnoparking3.png'
		},{
			src:'/images/smallnoparking2.png'
		},
		{
			src:'/images/smallnoparking4.png'
		},	
		]
		
		var largeImages=[{
			src:'/images/largenoparking1.png'
		},
		{
			src:'/images/largenoparkin2.png'
		},
		{
			src:'/images/largesmallnoparking3.png'
		},
		{
			src:'/images/largenoparkin4.png'
		},
		
		]
		
		var stickerImages=[{
			src:'/images/autobrandingsmall.png'
		},
		{
			src:'/images/autosticker2 (5).png'
		},
		{
			src:'/images/autosticker3 (3).png'
		}
		]
		
		
		var stickerLargeImages=[{
			src:'/images/sticker1.jpg'},
			{src:'/images/sticker2.jpg'},
			{src:'/images/sticker3.jpg'}
		]
		
		var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
		console.log("><><width",width)
		if(width<=951 && width>768){
		$scope.noimages=3;
		}else if(width<=768)
		{
			$scope.noimages=1
		}
		else
		{
			$scope.noimages=3
		}
		console.log("<><><><show",image)
		$scope.ShownImages=[];
		$scope.ShownImages = image.slice();
		console.log("shownimage",$scope.ShownImages)
		var ImageIndex =0;
		$scope.previousImage = function(){
			console.log("previous",image,$scope.ShownImages)
		if(ImageIndex < image.length && ImageIndex!=0){
			console.log("previousif",$scope.ShownImages,ImageIndex)
			$scope.ShownImages.splice(0,0,image[ImageIndex-1])
			console.log("previousif",$scope.ShownImages)
			ImageIndex--;
			if(ImageIndex==0){
				$scope.previous_active=false;
				$scope.next_active=true;
			}
			$scope.next_active=true;
		}
		
		}
		
		$scope.nextImage = function(){
			console.log("nextr")
			console.log("previous",image,$scope.ShownImages)
			if(ImageIndex+$scope.noimages < image.length){
				$scope.ShownImages.splice(0,1)
				console.log("previous",image,$scope.ShownImages)
				ImageIndex++;
				$scope.previous_active=true;
				if(ImageIndex+$scope.noimages == image.length){
					$scope.previous_active=true;
					$scope.next_active=false
				}
			}
		}
		
		$scope.openImage = function(index,type){
			console.log("<><openimage",index)
			var modal = document.getElementById('myModal');
			var modalImg = document.getElementById("img01");
			modal.style.display = "block";
			console.log("<><<>largeImages[index]"),largeImages[index]
			if(type=="hoods")
			modalImg.src = largeImages[index+ImageIndex].src;
			else
			modalImg.src= stickerLargeImages[index].src;
		}
		
		
		$scope.closeImg = function(){
			var modal = document.getElementById('myModal');
			modal.style.display = "none";
		}
		
		
		var stickerImageIndex=0;
		$scope.StickerShownImages=stickerImages.slice()
		
		$scope.stickerpreviousImage = function(){
			if(stickerImageIndex < stickerImages.length && stickerImageIndex!=0){
				$scope.StickerShownImages.splice(0,0,stickerImages[stickerImageIndex-1])
				stickerImageIndex--;
			}
		}
		
		$scope.stickernextImage = function(){
			if(stickerImageIndex+2 < stickerImages.length){
				for(var  i=0;i<3;i++){
					$scope.StickerShownImages[i]=$scope.StickerShownImages[i+1]
				}
				stickerImageIndex++;
			}
		}
		$scope.notcloseImage=function(event){
			event.stopImmediatePropagation();
			return false;
		}
		
		}]).controller('PamphletInsertionDistributionCtrl',['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location',function($scope, $window, $rootScope, API, $routeParams, $location){
			window.onbeforeunload = function () {
				console.log("><><<>")
				window.scrollTo(0, 0);
			  }
			  window.onbeforeunload()
		
		
			var stickerImages=[{
				src:'/images/smallpop1.png'
			},
			{
				src:'/images/pop2.png'
			},
			]
		
		
			var stickerLargeImages=[{
				src:'/images/largepop2.png'
			},
			{
				src:'/images/largepop1.png'
			},	
			]
		
			var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			console.log("><><width",width)
			if(width<=951 && width>768){
			$scope.noimages=3;
			}else if(width<=768)
			{
				$scope.noimages=1
			}
			else
			{
				$scope.noimages=3
			}
			

			
		
		
			$scope.openImage = function(index,type){
				console.log("<><openimage")
				var modal = document.getElementById('myModal');
				var modalImg = document.getElementById("img01");
				modal.style.display = "block";
				console.log("<><<>largeImages[index]")
				if(type=="hoods")
				modalImg.src = largeImages[index].src;
				else
				modalImg.src= stickerLargeImages[index].src;
			}
		
		
			$scope.closeImg = function(){
				var modal = document.getElementById('myModal');
				modal.style.display = "none";
			}
		
		
			var stickerImageIndex=0;
			$scope.StickerShownImages=stickerImages.slice()
		
			$scope.stickerpreviousImage = function(){
				if(stickerImageIndex < stickerImages.length && stickerImageIndex!=0){
					$scope.StickerShownImages.splice(0,0,stickerImages[stickerImageIndex-1])
					stickerImageIndex--;
				}
			}
		
			$scope.stickernextImage = function(){
				if(stickerImageIndex+2 < stickerImages.length){
					for(var  i=0;i<3;i++){
						$scope.StickerShownImages[i]=$scope.StickerShownImages[i+1]
					}
					stickerImageIndex++;
				}
			}
			$scope.notcloseImage=function(event){
				event.stopImmediatePropagation();
				return false;
			}
			}]).controller('newspaperCtrl',['$scope', '$window', '$rootScope', 'API', '$routeParams', '$location',function($scope, $window, $rootScope, API, $routeParams, $location){
				window.onbeforeunload = function () {
					console.log("><><<>")
					window.scrollTo(0, 0);
				  }
				  window.onbeforeunload()
			var image=[{
				src:'/images/newspaper1.png'
			},
			{
				src:'/images/newspaper2.png'
			},
			]
			
			var largeImages=[{
				src:'/images/nespaperLager1.jpg'
			},
			{
				src:'/images/largenewspaper2.jpg'
			},
			]
			
			var stickerImages=[{
				src:'/images/newspapersticker1.png'
			},
			{
				src:'/images/stickernewspaper2.png'
			},
			]
			
			
			var stickerLargeImages=[{
				src:'/images/stickernewspaper1.png'},
				{src:'/images/largenewspaper2.png'},		
			]
			
			var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			console.log("><><width",width)
			if(width<=951 && width>768){
			$scope.noimages=3;
			}else if(width<=768)
			{
				$scope.noimages=1
			}
			else
			{
				$scope.noimages=3
			}
			console.log("<><><><show",image)
			$scope.ShownImages=[];
			$scope.ShownImages = image.slice();
			console.log("shownimage",$scope.ShownImages)
			var ImageIndex =0;
			$scope.previousImage = function(){
				console.log("previous",image,$scope.ShownImages)
			if(ImageIndex < image.length && ImageIndex!=0){
				console.log("previousif",$scope.ShownImages,ImageIndex)
				$scope.ShownImages.splice(0,0,image[ImageIndex-1])
				console.log("previousif",$scope.ShownImages)
				ImageIndex--;
			}
			}
			
			$scope.nextImage = function(){
				console.log("nextr")
				console.log("previous",image,$scope.ShownImages)
				if(ImageIndex+3 < image.length){
					$scope.ShownImages.splice(0,1)
					console.log("previous",image,$scope.ShownImages)
					ImageIndex++;
				}
			}
			
			$scope.openImage = function(index,type){
				console.log("<><openimage",index)
				var modal = document.getElementById('myModal');
				var modalImg = document.getElementById("img01");
				modal.style.display = "block";
				console.log("<><<>largeImages[index]"),largeImages[index]
				if(type=="hoods")
				modalImg.src = largeImages[index+ImageIndex].src;
				else
				modalImg.src= stickerLargeImages[index].src;
			}
			
			
			$scope.closeImg = function(){
				var modal = document.getElementById('myModal');
				modal.style.display = "none";
			}
			
			
			var stickerImageIndex=0;
			$scope.StickerShownImages=stickerImages.slice()
			
			$scope.stickerpreviousImage = function(){
				if(stickerImageIndex < stickerImages.length && stickerImageIndex!=0){
					$scope.StickerShownImages.splice(0,0,stickerImages[stickerImageIndex-1])
					stickerImageIndex--;
				}
			}
			
			$scope.stickernextImage = function(){
				if(stickerImageIndex+2 < stickerImages.length){
					for(var  i=0;i<3;i++){
						$scope.StickerShownImages[i]=$scope.StickerShownImages[i+1]
					}
					stickerImageIndex++;
				}
			}
			
			$scope.notcloseImage=function(event){
				event.stopImmediatePropagation();
				return false;
			}
			}])